import { Autocomplete, Title } from "@mantine/core";
import React from "react";
import { useSelector } from "react-redux";

const QuickSearch = () => {
  const gearListArray = useSelector((state) => state.gear.gearList);

  const data = gearListArray.map((item) => ({ ...item, value: item.name }));

  return (
    <div>
      <Title order={3}>QuickSearch</Title>
      <Autocomplete limit={3} placeholder="Pick rent items" data={data} />
    </div>
  );
};

export default QuickSearch;
